/**
 * Linn & Paw — Cat Profile Quiz
 * Vanilla JS, no dependencies
 */

var PRODUCT_SCORES = {
  'the-vesper-bed': {
    age: { kitten: 8, adult: 10, senior: 7 },
    living: { indoor: 10, 'indoor-outdoor': 8, outdoor: 5 },
    temperament: { independent: 10, playful: 6, social: 8, anxious: 9 },
    priority: { wellness: 6, furniture: 10, grooming: 0, 'smart-tech': 5 },
    style: { light: 10, warm: 8, cool: 7, any: 8 },
  },
  'the-helia-fountain': {
    age: { kitten: 8, adult: 10, senior: 10 },
    living: { indoor: 10, 'indoor-outdoor': 9, outdoor: 6 },
    temperament: { independent: 8, playful: 7, social: 8, anxious: 7 },
    priority: { wellness: 10, furniture: 4, grooming: 0, 'smart-tech': 8 },
    style: { light: 8, warm: 7, cool: 9, any: 8 },
  },
  'the-reka-tracker': {
    age: { kitten: 5, adult: 10, senior: 7 },
    living: { indoor: 2, 'indoor-outdoor': 8, outdoor: 10 },
    temperament: { independent: 9, playful: 8, social: 6, anxious: 4 },
    priority: { wellness: 6, furniture: 0, grooming: 0, 'smart-tech': 10 },
    style: { light: 7, warm: 7, cool: 8, any: 8 },
  },
  'the-sonn-dispenser': {
    age: { kitten: 7, adult: 10, senior: 9 },
    living: { indoor: 10, 'indoor-outdoor': 8, outdoor: 5 },
    temperament: { independent: 9, playful: 7, social: 6, anxious: 7 },
    priority: { wellness: 9, furniture: 4, grooming: 0, 'smart-tech': 10 },
    style: { light: 7, warm: 6, cool: 9, any: 8 },
  },
  'the-iva-brush': {
    age: { kitten: 7, adult: 10, senior: 9 },
    living: { indoor: 9, 'indoor-outdoor': 9, outdoor: 8 },
    temperament: { independent: 7, playful: 8, social: 10, anxious: 9 },
    priority: { wellness: 6, furniture: 0, grooming: 10, 'smart-tech': 0 },
    style: { light: 9, warm: 10, cool: 7, any: 8 },
  },
  'the-lyse-trimmer': {
    age: { kitten: 6, adult: 10, senior: 9 },
    living: { indoor: 9, 'indoor-outdoor': 8, outdoor: 7 },
    temperament: { independent: 7, playful: 6, social: 8, anxious: 9 },
    priority: { wellness: 5, furniture: 0, grooming: 10, 'smart-tech': 7 },
    style: { light: 8, warm: 7, cool: 9, any: 8 },
  },
  'the-sora-bowl-set': {
    age: { kitten: 8, adult: 10, senior: 10 },
    living: { indoor: 10, 'indoor-outdoor': 9, outdoor: 6 },
    temperament: { independent: 8, playful: 7, social: 9, anxious: 8 },
    priority: { wellness: 10, furniture: 7, grooming: 0, 'smart-tech': 0 },
    style: { light: 10, warm: 9, cool: 8, any: 8 },
  },
  'the-maela-mat': {
    age: { kitten: 7, adult: 9, senior: 8 },
    living: { indoor: 10, 'indoor-outdoor': 8, outdoor: 6 },
    temperament: { independent: 7, playful: 6, social: 8, anxious: 7 },
    priority: { wellness: 8, furniture: 5, grooming: 7, 'smart-tech': 0 },
    style: { light: 9, warm: 8, cool: 8, any: 8 },
  },
  'the-aalto-tower': {
    age: { kitten: 10, adult: 10, senior: 6 },
    living: { indoor: 10, 'indoor-outdoor': 9, outdoor: 4 },
    temperament: { independent: 8, playful: 10, social: 9, anxious: 6 },
    priority: { wellness: 5, furniture: 10, grooming: 0, 'smart-tech': 0 },
    style: { light: 9, warm: 10, cool: 7, any: 8 },
  },
};

(function () {
  'use strict';

  var STEPS = ['age', 'living', 'temperament', 'priority', 'style'];
  var TOTAL = 5;

  var state = {
    step: 1,
    answers: { age: null, living: null, temperament: null, priority: null, style: null },
  };

  var els = {};

  function init() {
    var quiz = document.querySelector('.cat-quiz');
    if (!quiz) return;

    els.quiz = quiz;
    els.steps = quiz.querySelectorAll('.quiz-step');
    els.progress = quiz.querySelector('.quiz-progress__fill');
    els.indicator = quiz.querySelector('.quiz-step-indicator');
    els.continueBtn = quiz.querySelector('.quiz-continue');
    els.backBtn = quiz.querySelector('.quiz-back');
    els.results = quiz.querySelector('.quiz-results');
    els.resultsGrid = quiz.querySelector('.quiz-results__grid');
    els.resultsSub = quiz.querySelector('.quiz-results__subtitle');
    els.nav = quiz.querySelector('.quiz-nav');

    quiz.querySelectorAll('.quiz-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectOption(this);
      });
    });

    els.continueBtn.addEventListener('click', nextStep);
    els.backBtn.addEventListener('click', prevStep);

    var restartBtn = quiz.querySelector('.quiz-restart');
    if (restartBtn) restartBtn.addEventListener('click', restart);

    var emailForm = quiz.querySelector('.quiz-email-form');
    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = this.querySelector('input[type="email"]');
        var msg = this.querySelector('.quiz-email-msg');
        if (input && input.value) {
          fetch('/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body:
              'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter%2Cquiz-taker&contact%5Bemail%5D=' +
              encodeURIComponent(input.value),
          })
            .then(function () {
              if (msg) {
                msg.textContent = 'Saved. Check your inbox.';
                msg.style.display = 'block';
              }
              input.value = '';
            })
            .catch(function () {
              if (msg) {
                msg.textContent = 'Something went wrong. Please try again.';
                msg.style.display = 'block';
              }
            });
        }
      });
    }

    render();
  }

  function selectOption(el) {
    var stepKey = STEPS[state.step - 1];
    state.answers[stepKey] = el.dataset.value;

    var stepEl = el.closest('.quiz-step');
    stepEl.querySelectorAll('.quiz-option').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    el.classList.add('is-selected');

    els.continueBtn.disabled = false;
  }

  function nextStep() {
    if (state.step < TOTAL) {
      state.step++;
      render();
    } else {
      showResults();
    }
  }

  function prevStep() {
    if (state.step > 1) {
      state.step--;
      render();
    }
  }

  function render() {
    els.steps.forEach(function (s) {
      s.style.display = 'none';
    });
    var current = els.quiz.querySelector('[data-step="' + state.step + '"]');
    if (current) current.style.display = 'block';

    if (els.results) els.results.style.display = 'none';
    if (els.nav) els.nav.style.display = 'flex';

    els.progress.style.width = (state.step / TOTAL) * 100 + '%';
    els.indicator.textContent = '\u2014 Step ' + state.step + ' of ' + TOTAL;

    var stepKey = STEPS[state.step - 1];
    els.continueBtn.disabled = !state.answers[stepKey];
    els.backBtn.style.display = state.step === 1 ? 'none' : 'inline-block';
    els.continueBtn.textContent = state.step === TOTAL ? 'See your pieces' : 'Continue';
  }

  function calculateRecommendations() {
    var scores = {};
    for (var handle in PRODUCT_SCORES) {
      var w = PRODUCT_SCORES[handle];
      scores[handle] =
        (w.age[state.answers.age] || 0) +
        (w.living[state.answers.living] || 0) +
        (w.temperament[state.answers.temperament] || 0) +
        (w.priority[state.answers.priority] || 0) * 1.5 +
        (w.style[state.answers.style] || 0);
    }
    return Object.keys(scores)
      .sort(function (a, b) {
        return scores[b] - scores[a];
      })
      .slice(0, 4);
  }

  function showResults() {
    els.steps.forEach(function (s) {
      s.style.display = 'none';
    });
    if (els.nav) els.nav.style.display = 'none';
    els.results.style.display = 'block';
    els.progress.style.width = '100%';
    els.indicator.textContent = '\u2014 Your suggestions';

    var handles = calculateRecommendations();
    renderCards(handles);
    renderSubtitle();
  }

  function renderCards(handles) {
    els.resultsGrid.innerHTML = handles
      .map(function (h) {
        var name = h.replace(/^the-/, '').replace(/-/g, ' ');
        name = 'The ' + name.charAt(0).toUpperCase() + name.slice(1);
        return (
          '<a href="/products/' +
          h +
          '" class="quiz-result-card">' +
          '<div class="quiz-result-card__image"></div>' +
          '<p class="quiz-result-card__title">' +
          name +
          '</p>' +
          '<p class="quiz-result-card__price">Loading...</p>' +
          '</a>'
        );
      })
      .join('');

    handles.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (p) {
          var card = els.resultsGrid.querySelector('[href="/products/' + h + '"]');
          if (!card) return;
          var img = card.querySelector('.quiz-result-card__image');
          var title = card.querySelector('.quiz-result-card__title');
          var price = card.querySelector('.quiz-result-card__price');
          title.textContent = p.title;
          price.textContent = (p.price / 100).toLocaleString('en', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
          });
          if (p.featured_image) {
            img.innerHTML =
              '<img src="' +
              p.featured_image.replace(/(\.[a-z]+)$/, '_480x$1') +
              '" alt="' +
              p.title.replace(/"/g, '&quot;') +
              '" loading="lazy">';
          } else {
            img.classList.add('quiz-result-card__image--placeholder');
            img.textContent = p.title;
          }
        })
        .catch(function () {});
    });
  }

  function renderSubtitle() {
    var labels = {
      age: { kitten: 'kitten', adult: 'adult', senior: 'senior' },
      living: { indoor: 'indoor', 'indoor-outdoor': 'indoor-outdoor', outdoor: 'outdoor-roaming' },
      priority: { wellness: 'wellness', furniture: 'comfort', grooming: 'grooming', 'smart-tech': 'smart support' },
      style: { light: 'light, minimal', warm: 'warm, earthy', cool: 'cool, architectural', any: 'function-first' },
    };
    var a = state.answers;
    els.resultsSub.textContent =
      'Based on a ' +
      labels.age[a.age] +
      ' ' +
      labels.living[a.living] +
      ' cat who prioritises ' +
      labels.priority[a.priority] +
      ' and prefers ' +
      labels.style[a.style] +
      ' interiors \u2014 these pieces fit best.';
  }

  function restart() {
    state.step = 1;
    state.answers = { age: null, living: null, temperament: null, priority: null, style: null };
    els.quiz.querySelectorAll('.quiz-option.is-selected').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    render();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
